import SPEEDS from '../constants/speeds';

const getNextSpeed = (currentSpeed) => {
  const speedValues = Object.values(SPEEDS);

  const currentSpeedIndex = speedValues.indexOf(currentSpeed);

  if (currentSpeedIndex === -1) {
    return currentSpeed;
  }

  // $FlowFixMe
  return currentSpeedIndex >= speedValues.length - 1 ?
  speedValues[0] :
  speedValues[currentSpeedIndex + 1];
};

export default getNextSpeed;